import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { searchArtistApi, assignArtistToUserApi } from "../api/artist.api";
import { loginAuth } from "../redux/actions/auth";
import { maybeSyncWorkspaceOnce } from "../redux/actions/billing";
import { showToast } from "../helper/ShowToast";
import { invalidateUrStudioQueries } from "./urstudio/urstudioScope";

export const useSearchArtist = ({ name, enabled = true }) => {
    return useQuery({
        queryKey: ["artist-search", name],
        queryFn: () => searchArtistApi({ name }),
        enabled: enabled && !!name?.trim(),
        staleTime: 60 * 1000,
        keepPreviousData: true,
        retry: false,

        onError: (error) => {
            if (!name?.trim()) return;

            const msg =
                error?.response?.data?.message ||
                error?.message ||
                "Failed to fetch search results";

            showToast("error", msg);
        },
    });
};

export const useAssignArtistToUser = ({ navigate }) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: assignArtistToUserApi,
        onSuccess: (res) => {
            const token = res?.data?.token;
            const user = res?.data?.user;
            const access = res?.data?.access || null;

            if (token) {
                localStorage.setItem("authToken", token);
            }
            if (token && user) {
                dispatch(loginAuth(token, user, access));
                // TODO(legacy-migration): Phase 2 — remove maybeSyncWorkspaceOnce after backend login sync is removed.
                dispatch(maybeSyncWorkspaceOnce());
                // Refresh UrStudio caches after first artist + workspace migration
                invalidateUrStudioQueries(queryClient);
            }
            showToast("success", "You’re all set to become an UpNComer. Let’s get you inside and start building.", {
                autoClose: 800,
                onClose: () => navigate("/dashboard", { state: { ...user, access } }),
            });
        },

        onError: (error) => {
            const msg = error?.response?.data?.message || error?.message || "Something went wrong";
            showToast('error', msg)
        },
    });
};